export default {"src":"/_next/static/media/ic-lock.d4bc2ae5.svg","height":21,"width":17,"blurWidth":0,"blurHeight":0};